<template>
  <div class="card bg-transparent my-3">
    <div class="card-header bg-light font-weight-bolder">
      <span>{{ $t('membersWrapper.counter.usersLimit') }}</span>
    </div>
    <div class="card-body">
      <div class="card-text">
        {{ $t('membersWrapper.counter.usersWithAccess') }} {{ formatedEntityType }}:
        <b>{{ itemsCount }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import WrapperMessages from '@/shared-modules/shared-components/wrappers/messages/wrapper.messages';
import { membersTableEntityTypes } from '@/shared-modules/shared-components/wrappers/constants/entity.members.constants';
export default {
  name: 'GfEntityMembersCounter',
  data() {
    return {
      entityTypesEnum: membersTableEntityTypes
    }
  },
  props: {
    entityType: {
      type: String,
      default: 'PROJECT'
    },
    itemsCount: {
      type: Number,
      default: null
    }
  },
  computed: {
    formatedEntityType() {
      return this.$i18n.t(`membersWrapper.entityTypes.${this.entityTypesEnum[this.entityType]}`);
    }
  },
  i18n: {
    messages: WrapperMessages
  }
};
</script>
